export default __webpack_public_path__ + "static/media/meal-2.d0fc09e5.svg";